import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Server, Wifi, ShieldCheck, Plug, X } from "lucide-react";

// Connection / account summary banner for the global-markets page.
export const BrokerStatusCard = ({ b }) => {
  const { status, setConnectOpen, disconnect } = b;
  if (!status) return null;
  return (
    <Card className="p-5 mb-5 shadow-premium card-premium" data-testid="broker-status">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-lg bg-[color:var(--tharwy-lime)]/15 flex items-center justify-center shrink-0">
          <Server className="h-5 w-5 text-[color:var(--tharwy-lime-700)]" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-foreground">{status.venue}</span>
            <Badge variant="outline" className="gap-1 text-xs">
              <Wifi className="h-3 w-3" /> {status.connected ? "Connected" : "Disconnected"}
            </Badge>
            <Badge variant="secondary" className="text-xs uppercase" data-testid="broker-mode">{status.mode}</Badge>
            {status.paper && <Badge variant="outline" className="text-xs">Paper</Badge>}
            <span className="text-xs text-muted-foreground">Acct: {status.account_id}</span>
          </div>
          <p className="text-xs text-muted-foreground mt-2 flex gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5 mt-0.5 shrink-0 text-emerald-600" />{status.note}
          </p>
        </div>
        <div className="shrink-0 flex flex-col gap-2">
          {status.mode === "live" ? (
            <Button variant="secondary" size="sm" className="gap-1.5" onClick={disconnect} data-testid="broker-disconnect">
              <X className="h-3.5 w-3.5" /> Disconnect
            </Button>
          ) : (
            <Button size="sm" className="gap-1.5" onClick={() => setConnectOpen(true)} data-testid="broker-connect-open">
              <Plug className="h-3.5 w-3.5" /> Connect gateway
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};
